export const EMPTY_VALUE = "-";

/**
 * Formats a value, or returns the empty placeholder when it is absent.
 * Zero is a legitimate value (e.g. no down payment), so only `undefined` falls back.
 * @param value - The value to format.
 * @param format - Formats a present value.
 * @returns {string} The formatted value, or `-`.
 */
export function formatOptional<T>(value: T | undefined, format: (value: T) => string): string {
  return value === undefined ? EMPTY_VALUE : format(value);
}
